import type { StateCreator } from "zustand";
import type { ToolbarPensSlice } from "../../interfaces/slicesInterfaces/toolbarPensSlice";
import type { SetStateAction } from "react";


export const createToolbarPensSlice: StateCreator<
ToolbarPensSlice,
  [],
  [],
  ToolbarPensSlice
> = (set, get) => ({
  // Initial state
  activePen: "",
  openDropdown: "",

  // Pure state setter - no side effects
  setActivePen: (pen: string) => {
    console.log('[ToolbarPensSlice] setActivePen called:', pen);
    set({ activePen: pen });
  },

  // Pure state setter - no side effects
  setOpenDropdown: (dropdown: SetStateAction<string>) => {
    console.log('[ToolbarPensSlice] setOpenDropdown called:', dropdown);
    const newValue = typeof dropdown === 'function' ? dropdown(get().openDropdown) : dropdown;
    set({ openDropdown: newValue });
  },
});
